import React, { useContext, useEffect, useRef } from 'react';
import {PopupContext} from "../../App";
import {ScrollToPosition} from "../../utils/ScrollToPosition";
import {observer} from "mobx-react-lite";

const Popup = () => {
    const popupContent = useRef(null);
    const [popupContext, setPopupContext] = useContext(PopupContext);

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (popupContext && popupContent.current && !popupContent.current.contains(e.target)) {
                setPopupContext('');
                ScrollToPosition(true);
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [popupContext, setPopupContext]);

    return (
        <div id="js-popup" className="popup">
            <div className="message">
                <span>Please rotate your device!</span>
            </div>
            <div className="popup_content" ref={popupContent}>
                <div className="content">
                    <iframe id="js-fullscreen" width="560" height="315" src={popupContext}
                            title={popupContext}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen />
                </div>
                <div className="popup_nav">
                    <button
                        className="close"
                        id="js-popup_close"
                        type="button"
                        onClick={() =>{
                            setPopupContext('');
                            ScrollToPosition(true);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(Popup);